import { Injectable } from '@angular/core';
import { HttpClient, HttpHeaders } from '@angular/common/http';

import { environment } from '../../../environments/environment';

@Injectable()
export class RankingBecasService 
{
    constructor(private http: HttpClient) { }

    obtienePostulacionesAprobadas(idTipo: any, idCurso: any)
    { 
        return this.http.get(`${environment.urlBase}/becas/postulaciones/tipos/${idTipo}/cursos/${idCurso}`,
               { headers : this.armaCabecera() }).toPromise();
    }

    apruebaParaPago()
    {
        return this.http.put(`${environment.urlBase}/becas/postulaciones/estados/`, { a:'a' },
               { headers : this.armaCabecera() }).toPromise();
    }

    rankingAprobado()
    {
        return this.http.get(`${environment.urlBase}/postulaciones/becas/disponiblePago-pagadas`, 
               { headers : this.armaCabecera() }).toPromise();
    }

    listadoPreAprobacion()
    {
        return this.http.get(`${environment.urlBase}/postulaciones/becas/pre-aprobadas`, 
               { headers : this.armaCabecera() }).toPromise();
    }

    listadoResultado()
    {
        return this.http.get(`${environment.urlBase}/postulaciones/becas/aprobadas`, 
               { headers : this.armaCabecera() }).toPromise();
    }

    armaCabecera()
    {
        return new HttpHeaders({            
            'Content-Type':'application/json',
            'Authorization': 'Bearer ' + localStorage.getItem("jwt"),
            'Access-Control-Allow-Methods': 'GET, POST, PUT, PATCH, DELETE',
            'Access-Control-Allow-Origin': '*',
        });
    }
}